/**
 * Values copied from native enum JSMAppNavigatorTypes.swift
 */
export enum NavigationType {
  /**
   * Clears Home navigation controller and pushes target as root view controller on Home navigationController.
   */
  PUSH_AS_FIRST = "pushAsFirst",
  /*
   * Clears Home navigation controller stack and any presented view controllers and presents the viewcontroller.
   * NOTE: The viewcontroller being presented cant expect a delegate and should have the ability to close or exit itself.
   * This is a full screen presentation.
   */

  PRESENT_SHEET = "presentSheet",
  /*
   * Pushes the VJ view controller onto the current navigation stack.
   * VJ is presented as a full screen view.
   * This is used in RNHP fullscreen VJ experiment and Swipeable VJ experiment.
   */
  PUSH_WITH_CURRENT_NAV = "pushWithCurrentNav",
}
